import React from "react";
import Header from "../../../components/header/Header";
import { ReactComponent as Ok } from "../../../assets/icons/depositCrypto/Ok.svg";
import Button from "../../../components/button/Button";
import "./WithdrawApprove.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const WithdrawApprove = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="WithdrawApprove">
      <Header hasMenu2={true} />

      <div className="WithdrawApproveWrapper">
        <div className="Approve">
          <Ok />
          <h2>{t("WithdrawApprove.textMsg")}</h2>
          <Button
            onClick={() => navigate("../transactions")}
            text={t("WithdrawApprove.back")}
          />
        </div>
      </div>
    </div>
  );
};

export default WithdrawApprove;
